import { createI18n } from 'vue-i18n'

const i18n = createI18n({
    locale: 'ru',
    fallbackLocale: 'ru',
    messages: {
        ru: require('./common/locales/ru.json'),
        en: require('./common/locales/en.json'),
        kk: require('./common/locales/kk.json')
    }
})

export default i18n
